export type RoutingState =
  | {
      materialsVisitedFrom?: 'storage' | 'material'
    }
  | undefined
